<template>
  <v-app-bar app>
    <v-app-bar-nav-icon
      @click.stop="$emit('toggle-sidebar')"
    ></v-app-bar-nav-icon>
    <v-toolbar-title class="headline">
      <span>{{ $route.meta.title }}</span>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    {{ userName }}
    <v-menu left bottom>
      <template v-slot:activator="{ on }">
        <v-btn icon v-on="on">
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>

      <v-list min-width="180">
        <v-divider></v-divider>
        <v-list-item @click="logout">
          <v-list-item-content>
            <v-list-item-title>Sign Out</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>
export default {
  name: "Navbar",
  components: {},
  data() {
    return {
      userRole: ""
    };
  },
  async created() {
    if (this.$store.user) {
      this.userRole = this.$store.state.user.role;
    }
  },
  computed: {
    userName() {
      return this.$store.state.user.userName;
    }
  },
  methods: {
    logout() {
      this.$store.dispatch("logout");
    }
  }
};
</script>

<style scoped></style>
